import type CouponsStore from 'mobx/Coupons'
import type CouponFlowStore from 'mobx/CouponFlow'
import { createContext } from 'react'
import type CartStore from 'mobx/Cart/store'
import type AddressManagerV2Store from 'mobx/AddressManagerV2/store'
import type LocalizationStore from 'mobx/Localization/store'
import type EventStore from 'mobx/Events/stores'
import type Infra from 'mobx/Infra/Infra'
import type User from 'mobx/User/User'
import type Application from 'mobx/Application/Application'
import type Account from 'mobx/Account/Account'
import type Home from 'mobx/Home/Home'

export interface Stores {
	couponsStore: CouponsStore
	couponFlowStore: CouponFlowStore
	cartStore: CartStore
	addressManagerV2Store: AddressManagerV2Store
	localizationStore: LocalizationStore
	eventStore: EventStore
	infra: Infra
	user: User
	application: Application
	account: Account
	home: Home
}

const StoresContext = createContext<Stores | undefined>(undefined)

export default StoresContext
